var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.5 18.3334C13.7217 18.3334 16.3333 15.7217 16.3333 12.5C16.3333 9.27836 13.7217 6.66669 10.5 6.66669C7.27833 6.66669 4.66666 9.27836 4.66666 12.5C4.66666 15.7217 7.27833 18.3334 10.5 18.3334Z",
    fill: "#525154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4175 8.33333H6.33332V6.66667C6.33332 4.36548 8.1988 2.5 10.5 2.5C12.8012 2.5 14.6667 4.36548 14.6667 6.66667V8.33333H14.5825M10.5 11.6667V13.3333M16.3333 12.5C16.3333 15.7217 13.7217 18.3333 10.5 18.3333C7.27833 18.3333 4.66666 15.7217 4.66666 12.5C4.66666 9.27834 7.27833 6.66667 10.5 6.66667C13.7217 6.66667 16.3333 9.27834 16.3333 12.5Z",
    stroke: "#525154",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.85c0955175bec120a69cbd65ba50ccc2.svg";
export { ForwardRef as ReactComponent };